import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M21.742 10.38c-.46-.154-1.884.222-2.532-.025-.06-.022.343.55-.09.789.26.262 2.283-.29 2.447-.034.014.011-5.174 4.012-3.484 7.914.775-1.486 3.265.18 4.095.948-1.981.314-3.058.04-4.095-.509-1.947-1.62-1.266-4.918.775-6.685.127-.095.87-.493.87-.599 0-.125-1.707-.36-2.153-.489.106-.463.446-1.08.286-1.19s-.483-.023-.44.235c0 0-1.498.538-2.357.326-.008 0 0 .515-.36.595.155 1.122 2.483-.103 2.466.17-.011.032-3.393 1.938-2.31 4.922.467-1.19 1.855-.259 1.877.092.014.225-1.41.11-1.673.254.062.8.263 1.285.263 2.154-.7-.27-2.871-1.271-2.871-1.271-.147-.182-.456-.08-.456.151 0 .16.1.25.282.25.1 0 1.155.497 1.155.497s-.32.455-.224.588c.047.06.92 0 1.646.823.257.291.71 1.439 2.149 2.074.853.376 1.341-.706 1.341-.706s2.056.87 2.1.872c.527.012.711-.961.711-.961l2.276.795.766-1.002 2.333 1.002s.506-.974.48-1.002c-.328-.365-.491-.864-.491-.864l1.354-2.115s.758 0 .655-1.62c0 0 1.359-2.556 1.387-2.582.12-.117.133-.413-.199-.413s-.086.515-.418.556c-.38.048-1.918-.29-1.918-.29s-.854 1.52-.85 1.528c.008.003 1.99.144 1.998.151.007.004-.591 1.04-.591 1.04l-1.724.01s0 .78-.428 1.37c-1.005-2.954 1.56-5.707 1.823-5.756.224-.042.383-.16.383-.285 0-.129-.062-.19-.217-.208-.104-.012-1.468-.539-1.53-.592-.038-.03.457-.883.145-1.073-.414-.379-.43.235-.357.311-.666-.17-2.285.209-2.6.05.278.364.355.485-.097.761.702.353 2.346-.447 2.45 0-.465.36-5.29 3.372-2.968 8.215.368-1.173 1.747-2.244 2.681-1.037-.826.875-3.043 1.457-3.043 1.457-1.553-3.188-.082-6.132.08-6.405.228-.39.978-1.232.993-1.255.031-.053-1.603-1.13-1.603-1.168 0-.106.453-.93.248-1.107-.19-.164-.49.22-.437.343"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M10.667.314v10.353H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C7.412.821 8.933.518 10.667.314M.325 21.333h10.341v10.353c-1.733-.204-3.254-.508-4.324-.916C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M.34 10.667h10.327v10.666H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M.34 10.667q.109-.768.257-1.54L4.39 5.333l-1.52-1.52c.27-.334.571-.664.91-.976L5.332 4.39 9.205.519q.699-.115 1.462-.205v.629l-4.39 4.39 4.39 4.39v.944h-.943l-4.39-4.39-4.391 4.39z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M6 1.372v9.295H4.667V2.122c.403-.28.846-.535 1.333-.75",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M2.257 4.667h8.41V6h-9.14c.191-.415.431-.87.73-1.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m.299 10.966.367.367-.468.469q.045-.417.1-.836M3.333 12 4 11.333l-.667-.666-.667.666zm2 3.333L6 14l-.667-1.333L4.666 14zm-3.666 0L2.333 14l-.666-1.333L1 14zm7.333 0L9.667 14 9 12.667 8.334 14zm1.667 3.334V16L10 17.333zm-3.334 0L8 17.333 7.333 16l-.667 1.333zm-4 0L4 17.333 3.333 16l-.667 1.333zm-3.33-2.661.664 1.327-.612 1.223a38 38 0 0 1-.052-2.55M7.333 12 8 11.333l-.667-.666-.667.666zm-5.666 9.333.666-.666L1.667 20 1 20.667zm3.666 0L6 20.667 5.333 20l-.667.667zm3.667 0 .667-.666L9 20l-.666.667zM10.667 12v-1.333l-.667.666z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m1.394 25.696-.054-.129a.2.2 0 0 1 .03-.112l.12-.198a.2.2 0 0 1 .263-.073l.273.142a.2.2 0 0 0 .182.002l.42-.212a.2.2 0 0 0 .035-.335l-1.352-1.078-.009-.007a.2.2 0 0 1-.016-.283l.345-.387a.2.2 0 0 1 .337.063l.198.532a.2.2 0 0 0 .08.1l.41.258q.016.01.033.017a.2.2 0 0 0 .26-.112l.433-1.084a.2.2 0 0 1 .24-.118l1.122.312a.2.2 0 0 1 .146.215l-.077.698a.2.2 0 0 0 .225.22l1.707-.224q.017-.003.035-.002l1.7.076h.01a.2.2 0 0 0 .2-.2v-.127l-.002-.02a.2.2 0 0 0-.22-.18l-2.632.274a.2.2 0 0 1-.179-.077l-.15-.197a.2.2 0 0 1 .08-.306l1.149-.48a.2.2 0 0 1 .15 0l.307.12a.18.18 0 0 1 .042.313l-.202.153a.2.2 0 0 1-.12.04H5.806a.075.075 0 0 0-.064.115l.006.01a.2.2 0 0 0 .189.093l.819-.08.01-.001 1.689-.26a.2.2 0 0 1 .094.008l.631.21a.2.2 0 0 1 .136.177l.025.398a.2.2 0 0 1-.187.212l-.89.054a.132.132 0 0 0-.022.26l.71.168a.2.2 0 0 1 .154.204l-.036.85a.2.2 0 0 1-.273.178l-.433-.172a.134.134 0 0 1-.02-.239l.095-.057a.176.176 0 0 0 .067-.225l-.02-.045a.2.2 0 0 0-.153-.113l-1.343-.199-.029-.002a.2.2 0 0 0-.2.2v.242a.2.2 0 0 1-.132.188l-1.2.435a.2.2 0 0 1-.221-.06l-.141-.165a.2.2 0 0 1 .113-.325l.593-.121a.2.2 0 0 0 .158-.17l.023-.174a.183.183 0 0 0-.252-.192l-1.618.677-.025.008-2.165.588a.2.2 0 0 1-.168-.03l-.302-.212a.2.2 0 0 1-.03-.027m1.627 2.674.36-.903a.2.2 0 0 1 .24-.119l1.123.313a.2.2 0 0 1 .145.214l-.076.699a.2.2 0 0 0 .225.22l1.707-.224q.017-.002.035-.002l1.7.075h.01a.2.2 0 0 0 .2-.2v-.127l-.002-.02a.2.2 0 0 0-.22-.178l-2.632.273a.2.2 0 0 1-.179-.077l-.15-.197a.2.2 0 0 1 .082-.306l1.146-.48a.2.2 0 0 1 .151-.001l.307.121a.18.18 0 0 1 .042.312l-.202.154a.2.2 0 0 1-.12.04H5.806a.075.075 0 0 0-.064.115l.006.009a.2.2 0 0 0 .189.093l.819-.079.01-.001 1.689-.26a.2.2 0 0 1 .094.008l.631.21a.2.2 0 0 1 .136.177l.025.398a.2.2 0 0 1-.187.212l-.89.054a.132.132 0 0 0-.023.26l.712.168a.2.2 0 0 1 .153.203l-.036.851a.2.2 0 0 1-.273.177l-.433-.171a.134.134 0 0 1-.02-.239l.095-.058a.176.176 0 0 0 .067-.224l-.02-.046a.2.2 0 0 0-.153-.113l-1.343-.198-.029-.002a.2.2 0 0 0-.2.2v.241a.2.2 0 0 1-.132.188l-.954.346a8 8 0 0 1-.635-.353.2.2 0 0 1 .14-.108l.593-.12a.2.2 0 0 0 .158-.17l.023-.174a.183.183 0 0 0-.252-.192l-1.112.465a8.6 8.6 0 0 1-1.57-1.455",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M31.58 21.857q-.048.31-.104.622a3.7 3.7 0 0 1-.966-.444c-.745-.45-.802-.447-.835-.171-.118.947-.657.951-1.683.242-.313-.224-.694-.44-.688-.44-.142 0-.177.026-.177.034 0 1.056-.578 1.168-1.703.52-.822-.484-1.023-.54-1.136-.46a.75.75 0 0 0-.174.362c-.074.36-.239.646-.55.646-.165 0-.61-.197-1.028-.431-.41-.22-.814-.355-1.044-.364-.313 0-.285-.028-.373.422-.15.841-.713.777-1.724.084-.92-.616-.965-.622-1.23-.268-.244.313-.534.557-.773.557-.193 0-.59-.177-.99-.414-.668-.4-.926-.402-1.035-.157-.404.862-.899.83-1.997.03-.523-.382-.712-.388-1.151-.054-.501.385-.657.41-1.203.19a2 2 0 0 1-.35-.18v-.804c.35.402.828.51 1.148.264.684-.52 1.197-.504 1.95.045.808.59.828.591.996.232.32-.719 1.022-.715 1.984-.14.288.172.623.321.648.321-.048 0 .13-.149.243-.295.54-.72.954-.67 2.134.121.39.267.678.443.695.346.146-.746.367-.967 1.042-.967.36.015.853.18 1.35.446.202.114.599.267.602.253a1.36 1.36 0 0 1 .42-.77c.441-.32.832-.21 1.882.41.75.432.7.441.7.055 0-.432.371-.7.844-.7.2 0 .618.236 1.071.56.681.472.607.472.638.223.115-.944.751-.976 1.847-.316.183.116.466.328.72.39"
    }
  )
);
var SvgFlagSpm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSpm_default = SvgFlagSpm;

export { FlagSpm_default as default };
